import {
  AmbulanzesApi,
  AmsParametersApi,
  AppointmentExchangesApi,
  AppointmentsApi,
  AssetInventoryDocumentsApi,
  AssignmentsApi,
  BankruptcyChecklistApi,
  BannersApi,
  CaseNoteTemplatesApi,
  CaseNotesApi,
  ClaimsApi,
  ClientAppointmentsApi,
  ClientChangeHistoryApi,
  ClientNoteApi,
  ClientPortalAccountsApi,
  ClientVolunteerAssignmentsApi,
  ClientsApi,
  CounselorDocumentsApi,
  CounselorsApi,
  CourtHearingsApi,
  CourtsApi,
  CurrentUserApi,
  DocumentsApi,
  DutySchedulesApi,
  EdictsApi,
  EmailTemplatesApi,
  InternetRegistrationsApi,
  JournalSupportsApi,
  PriorityRequestsApi,
  ProceedingParticipantsApi,
  PublicHolidaysApi,
  SeizableIncomeCalculationApi,
  SettingsApi,
  SmsApi,
  SmsTemplatesApi,
  SrvProceedingApi,
  SystemDropdownsApi,
  SystemSettingsApi,
  TokenUploadApi,
  UserSettingsApi,
  ViennaAddressesApi,
  VolunteerPortalAccountsApi,
  VolunteersApi,
} from "./api-client";
import { apiConfiguration } from "./apiConfiguration";

// Re-export models for convenience
export * from "./api-client/models";
export { apiConfiguration } from "./apiConfiguration";

export const clientsApi = new ClientsApi(apiConfiguration);
export const clientChangeHistoryApi = new ClientChangeHistoryApi(apiConfiguration);
export const appointmentsApi = new AppointmentsApi(apiConfiguration);
export const appointmentExchangesApi = new AppointmentExchangesApi(apiConfiguration);
export const clientAppointmentsApi = new ClientAppointmentsApi(apiConfiguration);
export const assignmentsApi = new AssignmentsApi(apiConfiguration);
export const counselorsApi = new CounselorsApi(apiConfiguration);
export const settingsApi = new SettingsApi(apiConfiguration);
export const currentUserApi = new CurrentUserApi(apiConfiguration);
export const counselorDocumentsApi = new CounselorDocumentsApi(apiConfiguration);
export const documentsApi = new DocumentsApi(apiConfiguration);
export const assetInventoryDocumentsApi = new AssetInventoryDocumentsApi(apiConfiguration);
export const caseNotesApi = new CaseNotesApi(apiConfiguration);
export const ambulanzesApi = new AmbulanzesApi(apiConfiguration);
export const smsApi = new SmsApi(apiConfiguration);
export const bannersApi = new BannersApi(apiConfiguration);
export const proceedingParticipantsApi = new ProceedingParticipantsApi(apiConfiguration);
export const courtsApi = new CourtsApi(apiConfiguration);
export const courtHearingsApi = new CourtHearingsApi(apiConfiguration);
export const dutySchedulesApi = new DutySchedulesApi(apiConfiguration);
export const smsTemplatesApi = new SmsTemplatesApi(apiConfiguration);
export const caseNoteTemplatesApi = new CaseNoteTemplatesApi(apiConfiguration);
export const emailTemplatesApi = new EmailTemplatesApi(apiConfiguration);
export const systemDropdownsApi = new SystemDropdownsApi(apiConfiguration);
export const volunteersApi = new VolunteersApi(apiConfiguration);
export const volunteerPortalAccountsApi = new VolunteerPortalAccountsApi(apiConfiguration);
export const claimsApi = new ClaimsApi(apiConfiguration);
export const clientNoteApi = new ClientNoteApi(apiConfiguration);
export const journalSupportsApi = new JournalSupportsApi(apiConfiguration);
export const systemSettingsApi = new SystemSettingsApi(apiConfiguration);
export const amsParametersApi = new AmsParametersApi(apiConfiguration);
export const bankruptcyChecklistApi = new BankruptcyChecklistApi(apiConfiguration);
export const seizableIncomeCalculationApi = new SeizableIncomeCalculationApi(apiConfiguration);
export const tokenUploadApi = new TokenUploadApi(apiConfiguration);
export const clientPortalAccountsApi = new ClientPortalAccountsApi(apiConfiguration);
export const clientVolunteerAssignmentsApi = new ClientVolunteerAssignmentsApi(apiConfiguration);
export const viennaAddressesApi = new ViennaAddressesApi(apiConfiguration);
export const publicHolidaysApi = new PublicHolidaysApi(apiConfiguration);
export const edictsApi = new EdictsApi(apiConfiguration);
export const priorityRequestsApi = new PriorityRequestsApi(apiConfiguration);
export const srvProceedingApi = new SrvProceedingApi(apiConfiguration);
export const userSettingsApi = new UserSettingsApi(apiConfiguration);
export const internetRegistrationsApi = new InternetRegistrationsApi(apiConfiguration);
